export default __webpack_public_path__ + "static/interior-1471317_1280-20c9bdfc126fd180dc6b516c832b70db.png";